import api from "lib/api";

export const getSocialSecurityRate = async (params) => {
    return await api.post("/v1/SocialSecurityRate/getSocialSecurityRate", params);
};

export const updateSocialSecurityRate = async (params) => {
    return await api.post("/v1/SocialSecurityRate/updateSocialSecurityRate", params);
};